import { DepositPaymentStatus } from 'entities/Deposit';

export const DEPOSIT_STATUS_COLORS = {
  [DepositPaymentStatus.NOT_PAID]: 'text-primary',
  [DepositPaymentStatus.PAID]: 'text-success',
  [DepositPaymentStatus.PARTIAL_PAYMENT]: 'text-warn',
  [DepositPaymentStatus.PARTIAL_REFUND]: 'text-warn',
  [DepositPaymentStatus.CANCELLED]: 'text-error',
  [DepositPaymentStatus.REFUNDED]: 'text-indigo-600',
  [DepositPaymentStatus.NOT_REFUNDED]: 'text-primaryLight',
} as const;

export const getDepositStatusColor = (status: DepositPaymentStatus): string => {
  return DEPOSIT_STATUS_COLORS[status] || 'text-primary';
};
